module.exports = __webpack_public_path__ + "img/ppt.0386f1f2.png";